import React, { useState, useEffect, useContext } from 'react';

const Results = props => {
}

export default Results;
